import {get} from '../../../../DAL/data-provider';
import {Response, ProductsRelDocs} from '../interfaces';
import {getJSONFromHtml} from '../../../../domain/common';
import {
    getCategoryFromURL,
    sendGaEventProductDetails
} from "../../../../domain/marketing/gtm-provider";
import {abtest_ProductPageAddCartSBSTooltipVariants} from "../../../list-page/interfaces/interfaces";
import {getABTest, sendABTestAnalytics} from "../../../../domain/abtest/abtest-provider";

export const getInvertryData = async (nodeGUID: string) : Promise<Response> => {
    return get('/api/productpage/get-invertry-data', {
        nodeGUID
    });
};

export const getProductsRelDocs = () : ProductsRelDocs[] => {
    const data = getJSONFromHtml(document.getElementById('efs-data')) as ProductsRelDocs[];
    if(!data || !Array.isArray(data)) return [];
    //console.log('getProductsRelDocs: ',product);


    for(let i=0; i<data.length; i++){
        data[i] = normalizeProduct(data[i]);


    }
    //sort for ProductOptions min price
    if(data.length > 1 && data[0].isProductOptions)
    {
        //data.sort((a,b) => a.skuPrice - b.skuPrice);
        data.sort((a:any, b:any) => (a.minPrice > b.minPrice) ? 1 : -1)
    }

    return data;


};


export const normalizeProduct = (product: ProductsRelDocs) => {

    if(!product) return product;

    // properties with inner HTML - normalizations
    // product.note = product.note ? GeneralHelper.decodeURL(product.note) : '';
    // product.documentPageDescription = product.documentPageDescription ? GeneralHelper.decodeURL(product.documentPageDescription) : '';

    // computed properties
    product.withCouponEnabled = product.couponCampaignID > 0;
    product.isProductVisible = product.skuid > 0 && product.skuEnabled;
    product.isSamePrice = product.msrp === product.skuPrice;
    product.minPrice = !!product.note ? 'fake' : (product.couponPrice > 0 ? Math.min(product.skuPrice, product.couponPrice) : product.skuPrice);

    // https://wavesaudio.atlassian.net/browse/DSWEB-1264
    // Edited by Raz Liveyatan, 06.06.2021
    product.expectedShipping = product.expectedShipping !== '' ? product.expectedShipping : null;

    //Check for banners
    const bannerAbove = getJSONFromHtml(document.getElementById('product-page-banner-above')) as string;
    if(bannerAbove && bannerAbove.length > 0)
        product.bannerAbove = bannerAbove;

    return product;
};

export const createProductDetailsGA = (product: ProductsRelDocs) => {

    const skunumber = product.skuNumber;
    const name = product.documentName;
    const skuPrice = product.skuPrice;
    const productType = product.documentUrlPath !== '' ? getCategoryFromURL(product.documentUrlPath) : getCategoryFromURL(window.location.pathname);

    //console.log('createProductDetailsGA: ',product);
    const analyticsData = [{
        name: name
        ,id: skunumber
        ,price: skuPrice
        ,category: productType
    }];


    //console.log('sendProductDetailsGA:',analyticsData);
    sendGaEventProductDetails( analyticsData);

};

/*
* Waves.Misc ProductType
* */
export enum ProductTypeEnum{
    plugin="plugin",
    bundle="bundle",
    hardware="hardware",
    mixerrack="mixerrack",
    course="course",
    subscription="subscription",
    merch="merch"
}


export const rewriteWavesalias = () => {
    let _searchReplaced = "";

    if(!window.location.search || window.location.search === '' || window.location.search.indexOf('wavesalias') === -1)
        return _searchReplaced;

    let wavesaliasParam = '';
    let  otherParam = '';
    const _search =  window.location.search.substring(1);
    var _searchArr = _search.split('&');
    for (var i = 0; i < _searchArr.length; i++) {
        var pair = _searchArr[i].split('=');
        if (decodeURIComponent(pair[0]) === 'wavesalias') {
            wavesaliasParam = `#${decodeURIComponent(pair[1])}`;
        }
        else if(otherParam === ''){
            otherParam = `?${pair[0]}=${pair[1]}`;
        }
        else
            otherParam += `&${pair[0]}=${pair[1]}`;
    }
    _searchReplaced = otherParam + wavesaliasParam;
    //console.log('rewriteUrl: ',_searchReplaced);
    //const _searchReplaced = _search.replace("?wavesalias=","#").replace("&","?");
    //console.log('_searchReplaced: ',_searchReplaced);
    window.history.replaceState(null, '', document.location.pathname + _searchReplaced);
};

export const getABTest_ProductPageAddCartSBSTooltip = () : abtest_ProductPageAddCartSBSTooltipVariants => {
    let abtestVariant: abtest_ProductPageAddCartSBSTooltipVariants = abtest_ProductPageAddCartSBSTooltipVariants.hide;

    const abtest_ProductPageAddCartSBSTooltip = getABTest('ProductPageAddCartSBSTooltip');
    const abtest_ProductPageAddCartSBSTooltip_Enabled = !!abtest_ProductPageAddCartSBSTooltip && abtest_ProductPageAddCartSBSTooltip.isActive;
    if(abtest_ProductPageAddCartSBSTooltip_Enabled) {
        switch (abtest_ProductPageAddCartSBSTooltip.selected) {
            case 'hide' : {
                abtestVariant = abtest_ProductPageAddCartSBSTooltipVariants.hide;
                break;
            }
            case 'show' : {
                abtestVariant = abtest_ProductPageAddCartSBSTooltipVariants.show;
                break;
            }
            default : {
                abtestVariant = abtest_ProductPageAddCartSBSTooltipVariants.hide;
            }
        }
        sendABTestAnalytics(abtest_ProductPageAddCartSBSTooltip);
    }

    return  abtestVariant;

}